import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"chance-the-rapper-v2"> = {
  appId: "chance-the-rapper-v2",
  cookiePrefix: "ctr_v2",
  lang: "EN",
  artist: {
    name: "Chance The Rapper"
  },
  meta: {
    description: "Chance The Rapper"
  },
  emailSender: {
    name: "Chance The Rapper",
    email: "chancetherapper@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/chance-the-rapper`
      }
    },
    get files() {
      return {
        exclusives: `chance-the-rapper-exclusives`,
        fanClips: `chance-the-rapper/fan-clips`,
        merchSkus: `chance-the-rapper-merch-skus`,
        playlistCoverImages: `chance-the-rapper/playlist-cover-images`,
        showImages: `chance-the-rapper/show-images`,
        showCheckInRequestImages: `chance-the-rapper/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `chance-the-rapper/track-audios`,
        playlistDownloadFiles: `chance-the-rapper/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "faec7ec5-e11c-4750-a159-70b523f2c871",
    initialOwnerAddress: "0x4c6fa51e9f472c93ba597d2e2b8812e4c71ca9f9"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(1)
  },
  checkIn: {
    hidePrompt: false
  },
  shopUrl: "https://chancestuff.com/collections/all?utm_source=iyk&utm_medium=profile&utm_campaign=star_line",
  socialLinks: [
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://www.instagram.com/chancetherapper"
    },
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://www.facebook.com/chancetherapper"
    },
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://www.youtube.com/channel/UCeXp3EC97_rUl_e2vgM3gLg"
    },
    {
      platform: SocialPlatform.TikTok,
      label: "TikTok",
      href: "https://www.tiktok.com/@chancetherapper?lang=en"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "X",
      href: "https://x.com/chancetherapper"
    }
  ],
  joinProof: {
    name: "Chance The Rapper",
    get assets() {
      return {
        og: `${appConfig.s3.assets.appUrl}/og_image.jpg`,
        thumbnail: `${appConfig.s3.assets.appUrl}/join-proof.webp`,
        backgroundImage: `${appConfig.s3.assets.appUrl}/join-landing-background.webp`,
        image: `${appConfig.s3.assets.appUrl}/proof-image.jpg`,
        icon: `${appConfig.s3.assets.appUrl}/proof-icon.png`
      }
    }
  },
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og_image.jpg`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.svg`,
          width: 36
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email/chance-logo.png`,
            width: 36
          }
        },
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
